// extracted by mini-css-extract-plugin
export default {"content":"CancelAccessModal_content__RS4Lv zb-modal-body","subHeading":"CancelAccessModal_subHeading__rkjgq","modalFooter":"CancelAccessModal_modalFooter__-EVfx"};